<div fxFlex fxLayout="column" fxLayoutAlign="center center" (mouseover)="showLayoutButton()" (mouseleave)="hideLayoutButton()">
    <mat-progress-bar [value]="100" [color]="'accent'"></mat-progress-bar>
    <div fxFlex fxLayoutAlign="center center" class="default-layout mt-52" (click)="resetLayout()" *ngIf="showButton">
        <button mat-mini-fab matTooltip="Apresentar menu">
            <mat-icon aria-hidden="false" aria-label="Apresentar menu">tune</mat-icon>
        </button>
    </div>
</div>
